import { ReactNode } from 'react';

import { useResponsive } from '@flipster/react/misc/responsive/legacy';
import { SmartCardListWithPagination as CardList } from '@flipster/ui/CardList';
import { Col, Table, TableHeader } from '@flipster/ui/Table';

export interface Props<I> {
  isLoading: boolean;
  items: I[] | undefined;
  renderCardItem: (item: I, index: number) => ReactNode | null;
  renderTableItem: (item: I, index: number) => ReactNode | null;
  columns: Col[];
  pagination: {
    hasPrev: boolean;
    hasNext: boolean;
    cursorKey: keyof I;
    onChange: (params: { before?: string; after?: string }) => void;
  };
}

const TableList = <I,>({ isLoading, items, renderCardItem, renderTableItem, columns, pagination }: Props<I>) => {
  const { isDesktop } = useResponsive();

  if (isDesktop)
    return (
      <Table
        isLoading={isLoading}
        items={items}
        tHeader={<TableHeader bold={false} columns={columns} />}
        renderRow={renderTableItem}
        cursorPagination={pagination}
      />
    );
  return <CardList isLoading={isLoading} items={items} renderItem={renderCardItem} cursorPagination={pagination} />;
};

export default TableList;
